import BasePropertyView from 'BasePropertyView.js';
import Template         from 'workflow/properties/main/stage-description.ejs';
import util             from 'util/Util.js';


//=====================================================================
//
// An instance of this view represents a description in stage control.
//
// Leonardo  Ramirez, August 09, 2017
//
//=====================================================================

class MainStageDescriptionView extends BasePropertyView {

    initialize( opts ) {

        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change textarea'               : 'updateAttributes',
            'blur textarea'                 : 'lostFocus',
            'focus textarea'                : 'getFocus'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

   updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));
        this.model.set( propName, propVal );
        this.model.set({'widgetText': propVal});
    }


    render() {
        if(this.template) {            
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        return this;
    }

}

export default MainStageDescriptionView;
